<template>
  <gj-table
      ref="gjTable"
      adaptParent
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :offset-height="40"
      :pagination="pagination"
      :show-overflow="false"
      @page-change="$gjNoticeQuery">
    <!--            名称-->
    <template v-slot:logName="{ row }">
      <div style="color: #999">{{ row.objectType | optionsText(options.objectType) }}</div>
      <gj-tooltip :content="row.objectName">
        <div>{{ row.objectName }}</div>
      </gj-tooltip>
    </template>
    <!--            调整类型-->
    <template v-slot:operateType="{ row }">
      <div>{{ row.operateType | optionsText(options.opTypeOption) }}</div>
    </template>
    <!--            操作结果-->
    <template v-slot:result="{ row }">
      <div>
        {{ row.result | optionsText(options.resultOptions) }}
        <gj-tooltip v-if="row.detail" :content="row.detail">
          <i class="el-icon-arrow-down"></i>
        </gj-tooltip>
      </div>
    </template>

    <template v-slot:operationResult="{ row }">
      <div :style="{color: (row.operationResult === '成功' ? '#2DA641' : 'red')}">
        {{ row.operationResult  }}
        <gj-tooltip v-if="row.operationResult === '失败'" :content="row.detail">
          <i class="el-icon-arrow-down"></i>
        </gj-tooltip>
      </div>
    </template>

  </gj-table>
</template>

<script>
import {isMeaningfulMixin, queryMixin} from "@/minxins";
import {AdLog} from "@/views/modules/ad/common/enum";
import {AdStrategyEnum} from "@/views/modules/ad/strategy/common/enum";
import {isMeaningful} from "@/utils/common";
import {getAdsAdjustStrategyLog} from "@/api/ad";

export default {
  name: "auto-table",
  mixins: [queryMixin, isMeaningfulMixin],
  filters: {
    optionsText(val, options) {
      const item = options.find(e => e.id == val);
      return item ? item.text : val
    },
  },
  props:{
    model:{
      type: Object,
      default:()=>{}
    }
  },
  created() {
    this.options.objectType = AdLog().objOptions.filter(r => r.isShare)
    this.options.objectType.forEach(r => r.id = r.id2)
  },
  data(){
    return {
      tableData: [],
      columns: [
        {id: 'localUpdateDate', header: '操作时间（站点时间）', field: 'localUpdateDate', width: '160px', overflowLine: 1},
        {id: 'logName', header: '名称', field: 'slot:logName', minWidth: '280px', overflowLine: 1},
        {id: 'campaignName', header: '所属广告活动', field: 'campaignName', minWidth: '160px', overflowLine: 1},
        {id: 'groupName', header: '所属广告组', field: 'groupName', minWidth: '160px', overflowLine: 1},
        {id: 'operateType', header: '调整类型', field: 'slot:operateType', width: '110px', overflowLine: 1},
        {id: 'content', header: '调整记录', field: 'content', minWidth: '185px', overflowLine: 1},
        {id: 'operationResult', header: '操作结果', field: 'slot:operationResult', minWidth: '90px', overflowLine: 1},
        {id: 'updateDate', header: '操作时间（北京时间）', field: 'updateDate', width: '160px', overflowLine: 1},
      ],
      options: { // 枚举
        // 操作对象类型
        objectType: AdLog().objOptions,
        // 操作结果
        resultOptions: AdLog().resultOptions,
        // 操作类型
        opTypeOption: AdStrategyEnum.opTypeOption,
      }
    }
  },
  methods: {
    $gjQuery(){
      // 构造查询参数
      const params = {
        model:this.model,
        ...this.queryPagination,
        ...this.querySort
      };
      this.globalParams = params;
      // 查询
      this.loading = true;
      getAdsAdjustStrategyLog(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<style scoped>

</style>